export * as BREAKPOINTS from '../constants/breakpoints.js'
export * as COLORS from '../constants/colors.ts'
export * as FONTS from '../constants/fonts.js'

export { RegularText, ImportantText, DiscreteText, BoringText } from './Text.js'
export { PrimaryButton, SecondaryButton, TertiaryButton, ButtonWithIcon } from './Buttons.jsx'
export { default as SocialButton } from './SocialButton.jsx'
export { CallToAction, SecondaryCallToAction } from './CallToAction.jsx'
export { default as ProgressEgg } from './ProgressEgg.jsx'
export { default as ProjectCard } from './ProjectCard/index.jsx'
export { default as HorizontalProjectCard } from './ProjectCard/HorizontalProjectCard.jsx'
export { default as PartnerCard } from './PartnerCard.jsx'
export { default as CategoryCard } from './CategoryCard.jsx'
export { default as IllustratedTitle } from './IllustratedTitle.jsx'
export { Title1, Title2, Title3, Title4, Title5, Title6 } from './Titles.js'
export { PrimaryLink, SecondaryLink, TertiaryLink } from './Links.jsx'
export { default as Icon } from './Icon.jsx'
export { default as Avatar } from './Avatar.jsx'
export { LocaleMoneyDisplayer } from '../core/accounting/Accounting.jsx'
export { default as Footer } from './Footer/index.jsx'
export { default as Dropdown } from './Dropdown.jsx'
export { default as FilterButton } from './FilterButton.jsx'
export { default as DropdownFilter } from './DropdownFilter.jsx'
export { default as LoadMoreButton } from './LoadMoreButton.jsx'
export { default as FlashMessage } from './FlashMessage.jsx'
export { default as Pastille } from './Pastille.jsx'
export { default as Badge } from './Badge.jsx'
export { default as VideoLoader } from './VideoLoader.jsx'
export { default as SponsorshipBanner } from './sponsorship/Banner.jsx'
export { default as TinySponsorshipBanner } from './sponsorship/TinyBanner.jsx'
export { default as Sponsor } from './sponsorship/Sponsor.jsx'
export { default as UserCard } from './UserCard.jsx'
export { ClassicModal, NotificationModal, Dialog } from './Modal/index.jsx'
export { default as Carousel } from './Carousel/index.jsx'
export { RewardCard } from './RewardCard/RewardCard.jsx'
export { Variant } from './RewardCard/Variant.jsx'
export { Select as SimpleSelect } from './components/form/select/Select.jsx'
export { Option as SimpleOption } from './components/form/select/Option.jsx'
export { default as ErrorPage } from './ErrorPage.jsx'
export { default as Spinner } from './Spinner.jsx'
export { default as Tabs } from './Tabs.jsx'
export { default as Input } from './form/Input.jsx'
export { default as PhoneInput } from './form/PhoneInput/PhoneInput.jsx'
export { RadioOption, RadioGroup } from './form/Radio.jsx'
export { default as Checkbox } from './form/Checkbox.jsx'
export { default as Textarea } from './form/Textarea.jsx'
export { default as Select } from './form/Select.jsx'
export { default as MultiselectDropdown } from './dropdown/MultiselectDropdown.jsx'
export { default as ListFilter } from './dropdown/ListFilter.jsx'
export { default as TextEllipsis } from '../core/TextEllipsis.js'
export { default as Tag } from './Tag.jsx'
export { default as ClickOutside } from '../core/ClickOutside.jsx'
export { default as Jewel } from './Jewel.jsx'
export { default as RoundButton } from './RoundButton.jsx'
export { Tooltip } from './Tooltip.jsx'

if (typeof window !== 'undefined') {
  window.OWL_KIT_COMPONENTS_VERSION = 'OWL_KIT_VERSION / OWL_KIT_ENV'
}

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && typeof window !== 'undefined') {
  console.warn('[owl-kit-components] You currently use the non-production bundle of the library.') // eslint-disable-line no-console
  console.info(`owl-kit-components version: ${window.OWL_KIT_COMPONENTS_VERSION}`) // eslint-disable-line no-console
}
